// extracted by mini-css-extract-plugin
export var root = "index-module--root--8b962";